<template>

    <!-- Message -->
    <div :class="komentar.Prejemnik == 'SP' ? 'contract-details__message' : 'contract-details__message contract-details__message--inverted'"
        v-for="komentar in Komentarji">

        <!-- Message header -->
        <div class="contract-details__message__header">

            <!-- Message author -->
            <div class="contract-details__message__author">
                <div>{{ komentar.Prejemnik == 'SP' ? 'NLB Buy&Go' : komentar.Uporabnik }}</div>
            </div>

            <!-- Message timestamp -->
            <div class="contract-details__message__timestamp">{{ getDateTimeCorrectedFormat(komentar.Datum) }}</div>

        </div>

        <!-- Message content -->
        <div class="contract-details__message__content">

            <!-- Message text icon -->
            <div class="contract-details__message__text-icon">
                <!-- <img v-if="komentar.Prejemnik == 'SP' && komentar.Status == 'neprebran'"
                    src="@assets/images/contract-list/icon-message-gradient.svg" alt="Message">
                <img v-else-if="komentar.Prejemnik == 'SP' && komentar.Status == 'prebran'"
                    src="@assets/images/contract-list/icon-message-gradient-open.svg" alt="Message">
                <img v-else-if="komentar.Prejemnik != 'SP' && komentar.Status == 'neprebran'"
                    src="@assets/images/contract-list/icon-message-primary.svg" alt="Message">
                <img v-else src="@assets/images/contract-list/icon-message-primary-open.svg" alt="Message"> -->
                <!-- <img src="@assets/images/contract-list/icon-message-default.svg" alt="Message"> -->
            </div>

            <div  class="contract-details__message__text-wrap">
                <!-- Message text -->
                <div class="contract-details__message__text">{{ komentar.Komentar }}</div>

                <!-- Attachments -->
                <div class="contract-details__message__attachments">
                    <div class="contract-details__message__attachment" v-for="datoteka in komentar.Datoteke"
                        @click="fileId = datoteka.FileId">

                        <img src="@assets/images/contract-list/icon-attachment.svg" alt="Attachment">
                        {{ datoteka.FileName }}
                        <div :class="'tag tag--sm tag-attachment--' + datoteka.Status">
                            {{ i18n.global.t("CommentStatus." + datoteka.Status) }}
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <FileDownload :fileId="fileId" @formSubmitted="fileId = ''" />

</template>

<script setup lang="ts">
import { PropType, ref, Ref } from "vue";
import { IPogodbaKomentar } from "@/app/store/app/contract-list/store";
import { getDateTimeCorrectedFormat } from "@/app/utils/date-functions";
import { i18n } from "@app/i18n";
import FileDownload from "@components/file-download.vue";

defineProps({
    Komentarji: {
        type: Object as PropType<IPogodbaKomentar[]>,
        required: true
    }
})

// File Download

let fileId: Ref<string> = ref("");
</script>
